import React from 'react';  

const EmailLink = ({ children, className }: { children: any, className?: string }) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    window.location.href = `mailto:${children}`;
  };

  return (
    <span role='button' title={children} onClick={handleClick} className={className}>
    {children}
    </span>
  );
};

export default EmailLink;
